import React from 'react';

// import { Container } from './styles';

function ContractTable() {
  return <div />;
}

export default ContractTable;
